import { declareSlot } from '../../utils/slotsUtils';
import { SlotID } from '../basicSlotIDs';

type StageLayerSlotProps = {};

export const StageLayerSlot = declareSlot<StageLayerSlotProps>(
  SlotID.StageLayer,
);
